import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_text.svg'


const _withScopeId = n => (_pushScopeId("data-v-1c8c6f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container top-menu-holder" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "logo",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Aardvark logo"
  })
], -1))
const _hoisted_4 = { class: "mobile" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "mobile-menu" }
const _hoisted_10 = { class: "menu-holder" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Aardvark logo"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Menu, { class: "desktop" }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "burger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMobileMenu = !_ctx.showMobileMenu))
        }, _hoisted_8),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_FAIcon, {
                  icon: "times",
                  class: "ico",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMobileMenu = false))
                }),
                _createElementVNode("a", {
                  class: "logo",
                  href: "/",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMobileMenu = false))
                }, _hoisted_12),
                _createVNode(_component_Menu, {
                  onNavigate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showMobileMenu = false))
                })
              ])
            ], 512), [
              [_vShow, _ctx.showMobileMenu]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}